module.exports = __webpack_public_path__ + "static/media/herbie_great.7faaf96a.png";